export default __webpack_public_path__ + "assets/images/68013c13e041f7504c626ecb9696633e.png";